<div class="auth-main particles_js">
    <div class="auth_div vivify popIn">
        <div class="auth_brand">
            <a class="navbar-brand"><img src="https://sistemaperiodistas.com/crm_api/public/logo.png" width="60" height="60" class="d-inline-block align-top mr-2" alt=""></a>
        </div>
        <div class="card">
            <div class="body">
                <p class="lead">{{title}}</p>

               
            
                <div class="alert alert-danger" *ngIf="status == 'error'">
                    
                    El nombre de usuario o contraseña no es correcto, Intentelo de Nuevo
                </div>
            
                <form #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)" class="form-auth-small m-t-20">
            
                    <div class="form-group">
                        <label for="signin-email" class="control-label sr-only">Email</label>
                        <input type="email" class="form-control round" #email="ngModel" [(ngModel)]="user.email" name="email" placeholder="Email" required 
                        [ngClass]="{'is-invalid' : status == 'error'}"
                        >
                        <span *ngIf="!email.valid && email.touched">
                            El email no es válido
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="signin-password" class="control-label sr-only">Password</label>
                        <input type="password" class="form-control round" #password="ngModel" [(ngModel)]="user.password" 
                        [ngClass]="{'is-invalid' : status == 'error'}" name="password" required  placeholder="Password">
                        <span *ngIf="!password.valid && password.touched">
                            La contraseña no es valida
                        </span>
                    </div>
                    <div class="form-group clearfix">
                        <label class="fancy-checkbox element-left">
                            <input type="checkbox" #recuerdame="ngModel" [(ngModel)]="user.recuerdame" name="recuerdame">
                            <span>Recordarme</span>
                        </label>								
                    </div>
                    <button type="submit" class="btn btn-primary  btn-round btn-block" [disabled]="!loginForm.form.valid">
                    <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-sign-in':!loading, ' fa-refresh fa-spin':loading }"></i>
                    Envíar
                    </button>

                   

                </form>

                <div class="bottom" style="text-align: right; margin-top: 10px">
                    <span class="helper-text m-b-10"><i class="fa fa-lock"></i> <a [routerLink]="['../recovery_password']">¿Olvidaste tu contraseña?</a></span>
                </div>
                <div>ó</div>
                <a [routerLink]="['../register']" class=" btn btn-primary btn-round btn-block">Registrate</a>


                <!-- <form class="form-auth-small m-t-20" #loginForm="ngForm" (ngSubmit)="onSubmit(loginForm)">
                    <div class="form-group">
                        <label for="signin-email" class="control-label sr-only">Email</label>
                        <input type="email" class="form-control round" #email="ngModel" [(ngModel)]="user.email" placeholder="Email" required>
                        <span *ngIf="!email.valid && email.touched">
                            El email no es válido
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="signin-password" class="control-label sr-only">Password</label>
                        <input type="password" class="form-control round" #password="ngModel" [(ngModel)]="user.password" required  placeholder="Password">
                        <span *ngIf="!password.valid && password.touched">
                            La contraseña no es valida
                        </span>
                    </div>
                    <div class="form-group clearfix">
                        <label class="fancy-checkbox element-left">
                            <input type="checkbox">
                            <span>Remember me</span>
                        </label>								
                    </div>
                    <button type="submit" class="btn btn-primary btn-round btn-block" [disabled]="!loginForm.form.valid">LOGIN</button>
                    <div class="bottom">
                        <span class="helper-text m-b-10"><i class="fa fa-lock"></i> <a href="page-forgot-password.html">Forgot password?</a></span>
                        <span>Don't have an account? <a href="page-register.html">Register</a></span>
                    </div>
                </form> -->
            </div>
        </div>
    </div>
    <div id="particles-js"></div>
</div>